// extracted by mini-css-extract-plugin
module.exports = {"authorName":"AuthorNameInput_authorName__3x_4e","authorNameInput":"AuthorNameInput_authorNameInput__3hdPm"};